import React from 'react';
import { Form, FormGroup, FormControl, Button, } from 'react-bootstrap';
import config from '../../../config';
import { Chart, registerables } from 'chart.js';
import Select from 'react-select';
import moment from 'moment';
import utils from '../../utils';

//Chart.register(...registerables);

class DailyOEEReport extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            target: 0,
            tableHeader: '',
            selectedMachine: [],
            selectedCategory: 99,
            machineStr: '',
            originMachines: [],
            getmonth: moment().format('YYYY-MM'),
            categories: [{ value: 99, text: 'All' }, { value: 1, text: 'Machine' }, { value: 2, text: 'Line' }, { value: 3, text: 'SMT' }],
            startTime: ['06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '00:00', '01:00', '02:00', '03:00', '04:00', '05:00'],
            endTime: ['18:59', '19:59', '20:59', '21:59', '22:59', '23:59', '00:59', '01:59', '02:59', '03:59', '04:59', '05:59', '06:59', '07:59', '08:59', '09:59', '10:59', '11:59', '12:59', '13:59', '14:59', '15:59', '16:59', '17:59'],
            tableStyle: '<meta content="text/html; charset=UTF-8" http-equiv="Content-Type"><meta content="IE=8" http-equiv="X-UA-Compatible"><title>bcl_667529169.htm</title><meta content="BCL easyConverter SDK 5.0.08" name="generator"><style> th, td {width:auto, overflow:hidden;word-wrap:break-word;text-align: center;font-size: 10pt; border: 1px solid black; position: relative; }table{max-width:2490px;width:100%;background-color:white; border-collapse: collapse;}.left{padding:5px; text-align:left}.vertical-text{position: relative;height: 300px;width: 45px;margin-left: 0;padding-right: 10px;writing-mode: tb-rl;-webkit-transform: rotate(180deg);filter: flipv fliph;}.short{height:80px}</style>',
        };
        this.node = React.createRef();
    }

    componentWillMount() {
        this.setState({
            machines: []
        });
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };

        if (localStorage.getItem('user') != null)
            return fetch(`${config.apiUrl}/getAllMachines?company=${JSON.parse(localStorage.getItem('user')).accountId}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(machine => {
                    let data = [],
                        dynamicCategories = [{ text: 'All', value: 99 }];

                    // login successful if there's a user in the response
                    if (machine) {
                        machine.forEach(item => {
                            data.push({ 'id': item.id, 'label': item.machine, 'category': item.category, 'value': item.machine });
                            if (item.description && !dynamicCategories.some(cat => cat.value === item.category)) {
                                dynamicCategories.push({ text: item.description, value: item.category });
                            }
                        })

                        this.setState({ machines: data });
                        this.setState({ originMachines: data });
                        dynamicCategories.length > 1 && this.setState({ categories: dynamicCategories });

                        const { oee } = (() => {
                            try {
                                return { oee: JSON.parse(localStorage.getItem('monthlyTargetsOEE') || '{}') };
                            } catch (e) {
                                return { oee: {} };
                            }
                        })();
                        const month = new Date().getMonth() + 1;
                        const year = new Date().getFullYear();
                        const monthTarget = (oee[String(year)] && oee[String(year)][month]) || (localStorage.getItem('target1') || '80').split(',')[0];
                        this.setState({ target: monthTarget });

                        // Pre-select machine from URL query param if present
                        // App uses hash router: /#/dailyoeereport?machine=X, so parse from hash
                        const hashQuery = window.location.hash.includes('?') ? window.location.hash.split('?')[1] : '';
                        const urlParams = new URLSearchParams(hashQuery);
                        const machineName = urlParams.get('machine');
                        if (machineName) {
                            const matched = data.find(m => m.value === machineName);
                            if (matched) {
                                this.setState({ selectedMachine: [matched], selectedCategory: 99 }, () => {
                                    this.buildHtmlTable();
                                });
                                return machine;
                            }
                        }

                        this.buildHtmlTable();
                    }

                    return machine;
                });
    }

    componentDidMount() {
        const node = this.node;
        var ctx = document.getElementById("dailyOEEchart");
        ctx.style.backgroundColor = 'rgba(53,53,53,255)';
        Chart.defaults.global.defaultFontColor = '#B8B3B3';
        window.dailyOEEchart = new Chart(node, {
            type: 'bar',
            data: {
                datasets: [
                    {
                        label: 'Average',
                        data: [],
                        borderColor: 'rgb(255, 99, 132)',
                        backgroundColor: 'rgba(255, 99, 132)'
                    },
                    {
                        label: 'Target',
                        data: [],
                        type: 'line',
                        fill: false,
                        borderColor: "rgb(54, 162, 235)"
                    },
                ],
                labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
            },
            options: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        boxWidth: 20,
                        padding: 20,
                        generateLabels: function (chart) {
                            return chart.data.datasets.map(function (dataset, i) {
                                const iconCanvas = document.createElement('canvas');
                                iconCanvas.width = 20;
                                iconCanvas.height = 20;
                                const ictx = iconCanvas.getContext('2d');
                                if (i === 0) {
                                    ictx.fillStyle = 'rgba(255, 99, 132, 1)';
                                    ictx.fillRect(0, 0, 10, 20);
                                    ictx.fillStyle = 'rgba(40, 167, 69, 1)';
                                    ictx.fillRect(10, 0, 10, 20);
                                } else if (i === 1) {
                                    ictx.strokeStyle = "rgb(54, 162, 235)";
                                    ictx.lineWidth = 3;
                                    ictx.beginPath();
                                    ictx.moveTo(0, 10);
                                    ictx.lineTo(20, 10);
                                    ictx.stroke();
                                }
                                return {
                                    text: dataset.label,
                                    fillStyle: dataset.backgroundColor,
                                    hidden: !chart.isDatasetVisible(i),
                                    strokeStyle: dataset.borderColor,
                                    pointStyle: iconCanvas,
                                    datasetIndex: i
                                };
                            });
                        }
                    }
                },
                scales: {
                    xAxes: [{
                        display: true,
                        gridLines: {
                            display: true,
                            color: "#FFFFFF3"
                        }

                    }],
                    yAxes: [{
                        display: true,
                        gridLines: {
                            display: true,
                            color: "#FFFFFF2"
                        },
                        ticks: {
                            min: 0,
                            max: 100
                        }
                    }]
                },
                title: {
                    display: true,
                    text: ['PRODUCTION DAILY OVERALL EQUIPMENT EFFICIENCY PERFORMANCE( OEE )', 'Daily Target: ' + this.state.target + '% ']

                },
                plugins: {
                    labels: false
                }
            },
        });
    }

    tdWrap(content, target) {
        if (content == null)
            content = 0;
        let style = '';
        if (target && parseFloat(content) >= parseFloat(target)) {
            style = ' style="color: #28a745;"';
        }
        return '<td' + style + '>' + content + '</td>';
    }

    buildHtmlTable() {
        const { tableStyle, tableHeader } = this.state;
        const finalMachines = [];
        let header = '<table id="dailyoeereport" class="highlight-table" border=1; cellspacing=0/>'
            + '<tr>'
            + '<th style = "">Date</th>';
        let year = this.state.getmonth.substring(0, 4);
        let month = this.state.getmonth.substring(5, 7);
        let diff = new Date(year, month, 0).getDate();
        for (let i = 1; i <= diff; i++) {
            header += '<th style = "">' + i + '</th>'
            if (i == diff) {
                header += '<th style = "">MTD Average</th>'
                    + '</tr>';
            }
        };

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                machine: this.state.selectedMachine,
                month: this.state.getmonth,
            })
        };
        let query = `/getMachineOEEByDate?company=${JSON.parse(localStorage.getItem('user')).accountId}&start=${this.state.selectedStartTime}&end=${this.state.selectedEndTime}`;
        if (this.state.selectedCategory != 99) {
            query += `&category=${this.state.selectedCategory}`;
        }
        if (localStorage.getItem('user') != null) {
            return fetch(`${config.apiUrl}${query}`, requestOptions)
                .then((response) => {
                    return response.text().then(text => {
                        const data = text && JSON.parse(text);

                        return data;
                    });
                })
                .then(result => {
                    let mc = {};
                    let machine = {};
                    let avg = [];
                    let html = '';
                    let tgt = [];

                    mc = result.reduce(function (r, a) {
                        const key = parseInt((a.date).split('-')[2]);
                        r[a.machine] = r[a.machine] || [];
                        r[a.machine][key] = a.avg;
                        return r;
                    }, Object.create(null));

                    machine['target'] = this.state.target;
                    let countKey = 0;
                    // daySum[i]        = sum of non-zero values for day i across machines
                    // dayNonZeroCnt[i] = number of machines with non-zero value on day i
                    const daySum = new Array(diff).fill(0);
                    const dayNonZeroCnt = new Array(diff).fill(0);

                    for (let key in mc) {
                        let rowSum = 0, rowNonZero = 0;
                        html += '<tr>';
                        html += this.tdWrap(key);
                        for (let i = 1; i <= diff; i++) {
                            const val = parseInt(mc[key][i]) || 0;
                            html += this.tdWrap(Math.floor(val), machine.target);
                            if (val) { rowSum += val; rowNonZero++; daySum[i - 1] += val; dayNonZeroCnt[i - 1]++; }
                        }
                        html += this.tdWrap(rowNonZero > 0 ? Math.floor(rowSum / rowNonZero) : 0, machine.target);
                        html += '</tr>';
                        countKey++;
                    }

                    // Average row
                    html += '<tr>';
                    html += this.tdWrap('Average');
                    const dayAvgs = daySum.map((s, i) => dayNonZeroCnt[i] > 0 ? parseFloat((s / dayNonZeroCnt[i]).toFixed(1)) : 0);
                    dayAvgs.forEach(a => {
                        html += this.tdWrap(Math.floor(a), machine.target);
                        avg.push(a);
                        tgt.push(machine['target']);
                    });
                    const nonZeroDayAvgs = dayAvgs.filter(v => v > 0);
                    const ytdAvg = nonZeroDayAvgs.length > 0 ? Math.floor(nonZeroDayAvgs.reduce((a, b) => a + b, 0) / nonZeroDayAvgs.length) : 0;
                    html += this.tdWrap(ytdAvg, machine.target);
                    html += '</tr>';
                    countKey++;

                    //target
                    html += '<tr>';
                    html += this.tdWrap('Target');
                    for (let i = 0; i < diff; i++) {
                        html += this.tdWrap(machine.target);
                    }
                    html += this.tdWrap(machine.target + '%');
                    html += '</tr>';
                    let safeHTML = utils.sanitizeVoidTags((tableStyle + header + html.split('undefined').join(''))
                        .replaceAll('</img>', '')
                        .replaceAll('</input>', '')
                        .replaceAll('</br>', '<br/>')
                        .replaceAll('</hr>', '<hr/>'));

                    this.setState({ table: safeHTML });
                    this.drawChart(avg, tgt);
                    return machine;
                });
        }
    }
    exportExcel() {
        utils.tableToExcel('datatable', 'Report', 'DailyOEEReport_' + this.state.month + '.xls');
    };

    drawChart(d, m) {
        const backgroundColors = d.map((val, index) => (val >= m[index] ? 'rgba(40, 167, 69, 0.8)' : 'rgba(255, 99, 132, 0.8)'));
        const borderColors = d.map((val, index) => (val >= m[index] ? 'rgb(40, 167, 69)' : 'rgb(255, 99, 132)'));
        window.dailyOEEchart.data.datasets[0].backgroundColor = backgroundColors;
        window.dailyOEEchart.data.datasets[0].borderColor = borderColors;
        window.dailyOEEchart.data.datasets[0].data = d;
        window.dailyOEEchart.data.datasets[1].data = m;
        window.dailyOEEchart.options.title.text = ['PRODUCTION DAILY OVERALL EQUIPMENT EFFICIENCY PERFORMANCE( OEE )', 'Daily Target: ' + this.state.target + '% '];
        window.dailyOEEchart.update();
    }

    optionClicked(optionsList) {
        this.setState({ machines: optionsList });
    }
    selectedBadgeClicked(optionsList) {
        this.setState({ selectedMachine: optionsList });

    }

    filterMachines(categories) {
        let allmachines = [];

        if (categories == 99) {
            this.setState({ machines: this.state.originMachines })
        }
        else {
            for (let i = 0; i < this.state.originMachines.length; i++) {
                if (this.state.originMachines[i].category == categories)
                    allmachines.push({
                        'id': this.state.originMachines[i].id,
                        'label': this.state.originMachines[i].label,
                        'category': this.state.originMachines[i].category,
                        'value': this.state.originMachines[i].label
                    });
            }
            this.setState({ machines: allmachines })
        }
    }


    render() {
        const { tableStyle, tableHeader, tableContent } = this.state;
        const selectedOptionsStyles = {
            color: "#3c763d",
            backgroundColor: "#dff0d8"
        };
        const optionsListStyles = {
            backgroundColor: "#dff0d8",
            color: "#3c763d"
        };
        return (
            <div class="container">
                <div style={{ marginBbottom: '20em', position: 'relative', minHeight: '50px' }}>
                    <Form inline>
                        <FormGroup controlId="formInlineEmail">
                            <Form.Label>Month,Year</Form.Label>{' '}
                            <FormControl type="month"
                                className="daily-report-month-picker"
                                value={this.state.getmonth}
                                onChange={(e) => this.setState({ getmonth: e.target.value })}
                            />
                        </FormGroup>{' '}
                        <FormGroup controlId="formInlineName">
                            <Form.Label> Category:</Form.Label>{' '}
                            <FormControl as="select" placeholder="select"
                                value={this.state.selectedCategory} onChange={(e) => {
                                    if (e.target.value != 'select') {
                                        this.setState({ selectedCategory: e.target.value });
                                    } else {
                                        delete this.state.selectedCategory;
                                    }
                                    this.filterMachines(e.target.value);
                                }}>
                                <option value="0">select</option>
                                {
                                    this.state.categories.map((category) => {
                                        return <option key={category.value} value={category.value}>{category.text}</option>
                                    })
                                }
                            </FormControl>
                        </FormGroup>{'   '}
                        {this.state.selectedCategory != 99 && <FormGroup controlId="formInlineName">
                            <div class="col-xs-2" style={{ marginTop: '10px' }}>
                                <Form.Label> Items:</Form.Label></div>{' '}
                            <div class="col-xs-10" style={{ minWidth: '200px' }}>
                                <Select
                                    options={this.state.machines}
                                    isMulti
                                    onChange={this.selectedBadgeClicked.bind(this)}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                            </div>
                        </FormGroup>}{' '}
                        <FormGroup controlId="formInlineName">
                            <Form.Label>Start Time:</Form.Label>{' '}
                            <FormControl as="select" placeholder="select"
                                value={this.state.selectedStartTime} onChange={(e) => {
                                    if (e.target.value != 'select') {
                                        this.setState({ selectedStartTime: e.target.value });
                                    } else {
                                        delete this.state.selectedStartTime;
                                    }
                                }}>
                                <option value="0">select</option>
                                {
                                    this.state.startTime.map((time) => {
                                        return <option key={time} value={time}>{time}</option>
                                    })
                                }
                            </FormControl>
                        </FormGroup>{' '}
                        <FormGroup controlId="formInlineName">
                            <Form.Label>End Time:</Form.Label>{' '}
                            <FormControl as="select" placeholder="select"
                                value={this.state.selectedEndTime} onChange={(e) => {
                                    if (e.target.value != 'select') {
                                        this.setState({ selectedEndTime: e.target.value });
                                    } else {
                                        delete this.state.selectedEndTime;
                                    }
                                }}>
                                <option value="0">select</option>
                                {
                                    this.state.endTime.map((time) => {
                                        return <option key={time} value={time}>{time}</option>
                                    })
                                }
                            </FormControl>
                        </FormGroup>{' '}
                        <Button
                            bsStyle="primary"
                            style={{ float: "right", margin: 10 }}
                            // disabled={isLoading}
                            // onClick={!isLoading ? this.handleClick : null}
                            onClick={e => this.buildHtmlTable()}>Show</Button>
                    </Form>
                    <canvas id="dailyOEEchart" width="600" height="200" ref={node => (this.node = node)} style={{ marginTop: '10px' }}></canvas>
                    {this.state.table ? <div style={{ width: "100%" }}><Button
                        bsStyle="primary"
                        style={{ float: "right", margin: 10 }}
                        onClick={e => this.exportExcel()}>Export</Button></div> : ''}
                    <a id='dlink' style={{ display: 'none' }}></a>
                </div>
                <div id="datatable" class="container" style={{ overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: this.state.table }} />
            </div>
        );
    }
}

export { DailyOEEReport };